import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AidtLoginMutationVariables = Types.Exact<{
  input: Types.LoginAidtInput;
}>;


export type AidtLoginMutation = { __typename?: 'Mutation', loginAidt: { __typename?: 'LoginAidtPayload', token: string, partnerId: string, apiDomain: string, user: { __typename?: 'User', id: string, AIDigitalTextbook?: { __typename?: 'AIDigitalTextbook', userId?: string | null } | null } } };


export const AidtLoginDocument = gql`
    mutation AidtLogin($input: LoginAidtInput!) {
  loginAidt(input: $input) {
    token
    partnerId
    apiDomain
    user {
      id
      AIDigitalTextbook {
        userId
      }
    }
  }
}
    `;
export type AidtLoginMutationFn = Apollo.MutationFunction<AidtLoginMutation, AidtLoginMutationVariables>;

/**
 * __useAidtLoginMutation__
 *
 * To run a mutation, you first call `useAidtLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAidtLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aidtLoginMutation, { data, loading, error }] = useAidtLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAidtLoginMutation(baseOptions?: Apollo.MutationHookOptions<AidtLoginMutation, AidtLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AidtLoginMutation, AidtLoginMutationVariables>(AidtLoginDocument, options);
      }
export type AidtLoginMutationHookResult = ReturnType<typeof useAidtLoginMutation>;
export type AidtLoginMutationResult = Apollo.MutationResult<AidtLoginMutation>;
export type AidtLoginMutationOptions = Apollo.BaseMutationOptions<AidtLoginMutation, AidtLoginMutationVariables>;
export const namedOperations = {
  Mutation: {
    AidtLogin: 'AidtLogin'
  }
}